const appTheme = {};

export default appTheme;
